export const TIMELINE_DEFAULT_WIDTH = 860;
export const TIMELINE_DEFAULT_ZOOM = 0.1;
export const TIMELINE_MIN_ZOOM = 0.00390625;
export const TIMELINE_MAX_ZOOM = 0.4;
export const TIMELINE_TICK_WIDTH = 100;
export const TIMELINE_CANVAS_WIDTH = 360;
export const TIMELINE_CANVAS_HEIGHT = 90;
export const TIMELINE_CANVAS_LEVEL_WIDTH = 2;
export const TIMELINE_CANVAS_LEVEL_HEIGHT = TIMELINE_CANVAS_HEIGHT / 100;
export const TIMELINE_CANVAS_LEVEL_MARGIN = 1;
export const TIMELINE_CANVAS_LEVEL_STEP = TIMELINE_CANVAS_LEVEL_WIDTH + TIMELINE_CANVAS_LEVEL_MARGIN;
export const TIMELINE_CANVAS_LEVEL_COLOR = '#c5cae9';
export const TIMELINE_CANVAS_RECORDED_LEVEL_COLOR = '#4caf50';
export const KEYBOARD_ARROW_UP_KEY_CODE = 38;
export const KEYBOARD_ARROW_RIGHT_KEY_CODE = 39;
export const KEYBOARD_ARROW_DOWN_KEY_CODE = 40;
export const KEYBOARD_ARROW_LEFT_KEY_CODE = 37;
export const KEYBOARD_ENTER_KEY_CODE = 13;
export const SCRIPT_PROCESSOR_BUFFER_SIZE = 4096;
export const FIRST_LAYER_ID = 555811200000;
export const RECORD_TOKEN_KEY = 'record-token';



// WEBPACK FOOTER //
// ./src/app/constants.ts